import { $wait } from "@zotlo-shared/utils/wait"
import { api } from './api';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Packages {
  static get BASE_PATH() {
    if (import.meta.client) {
      return [globalThis?.location?.origin || '', 'api/packages'].join('/');
    }

    return 'packages';
  }

  static get PACKAGE_BASE_PATH() {
    if (import.meta.client) {
      return [globalThis?.location?.origin || '', 'api/package'].join('/');
    }

    return 'package';
  }

  static async getPackages(options?: { onlySelectedPackage?: boolean }, headers?: Record<string, any>) {
    try {
      $wait.start('getPackages');
      const { onlySelectedPackage = false } = options || {};
      const url = `${Packages.BASE_PATH}${onlySelectedPackage ? '?onlySelectedPackage=true' : ''}`
      const response = await api.get(url, headers);
      return response;
    } finally {
      $wait.end('getPackages');
    }
  }

  static async selectPackage(payload: Record<'packageId', number>, headers?: Record<string, any>) {
    const response = await api.post(`${Packages.PACKAGE_BASE_PATH}/select`, payload, headers);
    return response;
  }
}

export default Packages;
